import React from 'react';

import Content from '../../../shared/components/content/page';
import { useNavigate, useParams } from 'react-router-dom';
import { Expense } from '../../../shared/models/expense';
import { InvalidCircleIdError } from '../../../shared/models/errors/invalid-circle-id-error';
import { DynamicForm } from '../../../dynamic-forms/dynamic-form';
import { getInputs } from '../../../dynamic-forms/utils/get-inputs';
import { useExpenseContext } from '../../../contexts/expense/expense-context';
import Header from '../../../shared/components/header/page';
import accountService from '../../../shared/services/account-service';
import { InvalidAccessTokenError } from '../../../shared/models/errors/invalid-access-token-error';

const AddEditExpenseStep1 = () => {
	const { expense, setExpense } = useExpenseContext();

	const navigate = useNavigate();
	const { id: circleId } = useParams();
	if (!circleId) {
		throw new InvalidCircleIdError();
	}
	const account = accountService.getAccount();
	if (!account) {
		throw new InvalidAccessTokenError();
	}

	const goNext = (data: Expense) => {
		data.dateTime = data.dateTime ? new Date(data.dateTime) : undefined;
		setExpense({
			...expense,
			description: data.description,
			currency: (data.currency?.length ?? 0) > 0 ? data.currency : '₹',
			amount: data.amount,
			dateTime: data.dateTime,
			circleId: circleId,
			isSettlement: false,
			createdById: account.id,
		});
		navigate(`/secure/circles/${circleId}/add-expense/payee`);
	};

	return (
		<>
			<Header title="Details" subtitle={`Enter the details of the expense.`} />
			<Content>
				<div>
					<DynamicForm
						{...getInputs('add-edit-expense')}
						initialValues={expense ?? { dateTime: new Date() }}
						onSubmit={goNext}
						submitButtonType={'Button'}
						submitButtonTitle={'Next'}
					/>
				</div>
			</Content>
		</>
	);
};

export default AddEditExpenseStep1;
